module.exports = __webpack_public_path__ + "assets/e49dc7a3c8a0db7b256f4aedb83d6382.jpg";